import { render, staticRenderFns } from "./FooterDataTable.vue?vue&type=template&id=45553021&scoped=true"
import script from "./FooterDataTable.vue?vue&type=script&lang=js"
export * from "./FooterDataTable.vue?vue&type=script&lang=js"
import style0 from "./FooterDataTable.vue?vue&type=style&index=0&id=45553021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45553021",
  null
  
)

export default component.exports